
<loading-spinner *ngIf="isLoading"></loading-spinner>

<div id="page--letter-template">
  <form #f="ngForm">
    <div class="content__holder" *ngIf="!previewMode">
      <h2>Configure letters</h2>

      <!--<ul class="letter__list">
        <li class="letter__item">
          <mat-form-field>
            <mat-select id="letterTypes" name="letterTypes" [(ngModel)]="letterTypeId" (selectionChange)="letterTypeChanged()" placeholder="Letter Type">
              <mat-option *ngFor="let letterType of letterTypes" [value]="letterType.letterTypeId">
                {{letterType.letterTypeName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </li>
      </ul>-->
      <div class="panel">
        <ul class="grid grid--row-2" *ngIf="letterTemplate && !isLoading">
          <li>
            <mat-form-field fxFlex="100" class="edit-panel__material-holder">
              <mat-select id="letterTypes" name="letterTypes" [(ngModel)]="letterTypeId" (selectionChange)="letterTypeChanged()" placeholder="Letter Type">
                <mat-option *ngFor="let letterType of letterTypes" [value]="letterType.letterTypeId">
                  {{letterType.letterTypeName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </li>
        </ul>
      </div>

      <h2>From Address</h2>
      <div class="panel">
        <ul class="grid grid--row-1" *ngIf="letterTemplate && !isLoading">
          <li>
            <mat-form-field>
              <div class="validation__holder">
                <input matInput type="text" name="address" id="address" placeholder="Address" [(ngModel)]="letterTemplate.address" required />
                <div class="validation"></div>
              </div>
            </mat-form-field>
          </li>
        </ul>
      </div>

      <h2>Body</h2>
      <div class="panel">
        <ul class="grid grid--row-1" *ngIf="letterTemplate && !isLoading">
          <li>
            <mat-form-field>
              <div class="validation__holder">
                <input matInput type="text" name="salutation" id="salutation" placeholder="Salutation" [(ngModel)]="letterTemplate.salutation" required />
                <div class="validation"></div>
              </div>
            </mat-form-field>
          </li>

          <li>
            <mat-form-field>
              <div class="validation__holder">
                <textarea matInput type="text" name="content" id="content" placeholder="Letter Body" [(ngModel)]="letterTemplate.content" required></textarea>
                <div class="validation"></div>
              </div>
            </mat-form-field>
          </li>

          <li>
            <mat-form-field>
              <div class="validation__holder">
                <input matInput type="text" name="closing" id="closing" placeholder="Complimentary closing" [(ngModel)]="letterTemplate.complementaryClosing" required />
                <div class="validation"></div>
              </div>
            </mat-form-field>
          </li>

          <li>
            <mat-form-field>
              <div class="validation__holder">
                <input matInput type="text" name="name" id="name" placeholder="Name" [(ngModel)]="letterTemplate.name" required />
                <div class="validation"></div>
              </div>
            </mat-form-field>
          </li>
        </ul>
      </div>

      <div class="button__row" *ngIf="letterTemplate && !isLoading">
        <button class="button--box blue preview" (click)="preview()" [disabled]="isSaveDisabled()">Preview</button>
        <button class="button--box blue save" (click)="save()" [disabled]="isSaveDisabled()">Save</button>
      </div>
    </div>

    <!-- PREVIEW MODE -->
    <div class="content__holder letter-preview" *ngIf="previewMode">
      <h2 class="heading">Letter - {{letterTypeName}} (Preview)</h2>

      <div class="letter-preview__holder">
        <div class="letter-preview__paper-size">
          <img src="/assets/images/A4 Dimensions.jpg" class="letter-preview__paper-image" />
          <div class="letter-preview__paper">
            <ul class="letter-preview__list" *ngIf="previewMode">
              <li class="letter-preview__item addresses">
                <div class="letter-preview__receiver">
                  <p>[Receiver's Address]</p>
                </div>
                <div class="letter-preview__address">
                  <p innerHtml="{{getFormattedAddress}}"></p>
                </div>
              </li>
              <li class="letter-preview__item date">
                <p>{{getDate | date: 'dd/MM/yyyy'}}</p>
              </li>
              <li class="letter-preview__item">
                <p>{{letterTemplate.salutation}}</p>
              </li>
              <li class="letter-preview__item">
                <p [innerHTML]="getFormattedLetterBody"></p>
              </li>
              <li class="letter-preview__item">
                <p>{{letterTemplate.complementaryClosing}}</p>
              </li>
              <li class="letter-preview__item">
                <p>{{letterTemplate.name}}</p>
              </li>
              <!--<li class="letter-preview__item signature">
                <img src="{{letterTemplate.urlToSignature}}" />
              </li>-->
              <li class="letter-preview__item">
                <p></p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="button__row">
        <button class="button--box blue back" (click)="back()">Back</button>
      </div>

    </div>
    <!-- PREVIEW MODE -->

  </form>
</div>
